/**
 * Set debug mode for development purposes (more verbose console reporting)
 * To use this pass in the 'profile' GET arg, or 'debug'
 */
export default function checkAndSetDebugMode() {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let profile = url.searchParams.get("profile");
    let debug = url.searchParams.get("debug");
    if (profile !== null || debug !== null) {
        window.debug = true;
    } else {
        window.debug = false;
    }
}